import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { Purchase } from "../purchase/type";

export const purchaseListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<Purchase>>(
    url.search
      ? `/api/purchases${url.search}`
      : "/api/purchases?sort.field=creationTime&sort.sort=desc&pageSize=50"
  );
  return result.data;
};
